<div class="reconciliation-dashboard">
  <div #surfaceContainer class="reconciliation-dashboard__surface card">
    <div class="reconciliation-dashboard__toolbar-shell">
      <div class="reconciliation-dashboard__header-bar">
        <div class="reconciliation-dashboard__header-main">
          <button type="button" class="reconciliation-dashboard__back-button" (click)="goToMyReports()">
            <span class="reconciliation-dashboard__back-icon" aria-hidden="true">←</span>
            <span>My Reports</span>
          </button>

          <div class="reconciliation-dashboard__header-copy">
            <div class="reconciliation-dashboard__eyebrow">Reconciliation Report</div>
            <h2 class="reconciliation-dashboard__title">Production Reconciliation Dashboard</h2>
            <div class="reconciliation-dashboard__toolbar-meta">
              <span class="reconciliation-dashboard__meta-pill reconciliation-dashboard__meta-pill--accent">
                Alliance Group view
              </span>
              <span class="reconciliation-dashboard__meta-pill">Reporting weeks</span>
              <span class="reconciliation-dashboard__meta-pill">Carrier totals</span>
            </div>
          </div>
        </div>

        <div class="reconciliation-dashboard__header-side">
          <div class="reconciliation-dashboard__header-setup">
            <div class="reconciliation-dashboard__header-setup-copy">
              <span class="reconciliation-dashboard__header-setup-label">Setup</span>
              <span class="reconciliation-dashboard__header-setup-summary">{{ getDisplayedSetupSummary() }}&nbsp;</span>
            </div>
            <div class="reconciliation-dashboard__header-actions">
              <dx-button
                hint="Configure"
                type="default"
                stylingMode="contained"
                icon="preferences"
                (onClick)="openSetupModal()"
              ></dx-button>
              <dx-button
                hint="Fullscreen"
                type="normal"
                stylingMode="outlined"
                icon="agi-up-right-and-down-left-from-center"
                [disabled]="isLoadingSig()"
                (onClick)="toggleFullScreen(surfaceContainer)"
              ></dx-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <dx-popup
      [(visible)]="isSetupModalVisible"
      [showTitle]="true"
      title="Reconciliation Setup"
      [dragEnabled]="false"
      [hideOnOutsideClick]="true"
      [showCloseButton]="true"
      [width]="760"
      [height]="'auto'"
    >
      <div class="reconciliation-dashboard__modal">
        <dx-form
          #setupFormRef
          class="reconciliation-dashboard__modal-form"
          [formData]="draftSetup"
          [colCount]="2"
          [validationGroup]="setupValidationGroup"
          [showValidationSummary]="true"
          labelMode="floating"
          (onFieldDataChanged)="setupFormRef.instance.validate()"
        >
          <dxi-item itemType="group" caption="Reconciliation range" [colSpan]="2" [colCount]="2">
            <dxi-item itemType="group" [colSpan]="2" [colCount]="2">
              <dxi-item
                dataField="mode"
                editorType="dxSelectBox"
                [isRequired]="true"
                [label]="{ text: 'Mode' }"
                [editorOptions]="{
                  items: reconciliationModeOptions,
                  displayExpr: 'text',
                  valueExpr: 'id',
                  showClearButton: false,
                  onValueChanged: onDraftModeChange,
                }"
              >
                <dxi-validation-rule type="required" [message]="Messages.REQUIRED_TEXT"></dxi-validation-rule>
              </dxi-item>
            </dxi-item>

            @switch (draftSetup.mode) {
              @case ("ytd") {
                <dxi-item itemType="group" [colCount]="2">
                  <dxi-item
                    dataField="currentYear"
                    editorType="dxSelectBox"
                    [isRequired]="true"
                    [label]="{ text: 'Current year' }"
                    [editorOptions]="{
                      items: yearOptionsSig(),
                      displayExpr: 'text',
                      valueExpr: 'id',
                      showClearButton: false,
                      onValueChanged: onDraftCurrentYearChange,
                    }"
                  >
                    <dxi-validation-rule type="required" [message]="Messages.REQUIRED_TEXT"></dxi-validation-rule>
                    <dxi-validation-rule
                      type="custom"
                      [validationCallback]="validateDraftYearsAreDifferent"
                      message="Current year and compare year must be different"
                    ></dxi-validation-rule>
                  </dxi-item>

                  <dxi-item
                    dataField="compareYear"
                    editorType="dxSelectBox"
                    [isRequired]="true"
                    [label]="{ text: 'Compare year' }"
                    [editorOptions]="{
                      items: yearOptionsSig(),
                      displayExpr: 'text',
                      valueExpr: 'id',
                      showClearButton: false,
                      onValueChanged: onDraftCompareYearChange,
                    }"
                  >
                    <dxi-validation-rule type="required" [message]="Messages.REQUIRED_TEXT"></dxi-validation-rule>
                    <dxi-validation-rule
                      type="custom"
                      [validationCallback]="validateDraftYearsAreDifferent"
                      message="Current year and compare year must be different"
                    ></dxi-validation-rule>
                  </dxi-item>
                </dxi-item>

                <dxi-item
                  dataField="stopDate"
                  editorType="dxDateBox"
                  [isRequired]="true"
                  [label]="{ text: 'Stop date' }"
                  [editorOptions]="{
                    min: getDraftStopDateMin(),
                    max: getDraftStopDateMax(),
                    displayFormat: 'MM/dd',
                    showClearButton: false,
                    useMaskBehavior: true,
                    type: 'date',
                    onValueChanged: onDraftStopDateChange,
                  }"
                >
                  <dxi-validation-rule type="required" [message]="Messages.REQUIRED_TEXT"></dxi-validation-rule>
                </dxi-item>
              }

              @case ("range") {
                <dxi-item itemType="group" [colCount]="2">
                  <dxi-item
                    dataField="currentYear"
                    editorType="dxSelectBox"
                    [isRequired]="true"
                    [label]="{ text: 'Current year' }"
                    [editorOptions]="{
                      items: yearOptionsSig(),
                      displayExpr: 'text',
                      valueExpr: 'id',
                      showClearButton: false,
                      onValueChanged: onDraftCurrentYearChange,
                    }"
                  >
                    <dxi-validation-rule type="required" [message]="Messages.REQUIRED_TEXT"></dxi-validation-rule>
                    <dxi-validation-rule
                      type="custom"
                      [validationCallback]="validateDraftYearsAreDifferent"
                      message="Current year and compare year must be different"
                    ></dxi-validation-rule>
                  </dxi-item>

                  <dxi-item
                    dataField="compareYear"
                    editorType="dxSelectBox"
                    [isRequired]="true"
                    [label]="{ text: 'Compare year' }"
                    [editorOptions]="{
                      items: yearOptionsSig(),
                      displayExpr: 'text',
                      valueExpr: 'id',
                      showClearButton: false,
                      onValueChanged: onDraftCompareYearChange,
                    }"
                  >
                    <dxi-validation-rule type="required" [message]="Messages.REQUIRED_TEXT"></dxi-validation-rule>
                    <dxi-validation-rule
                      type="custom"
                      [validationCallback]="validateDraftYearsAreDifferent"
                      message="Current year and compare year must be different"
                    ></dxi-validation-rule>
                  </dxi-item>
                </dxi-item>

                <dxi-item [colSpan]="2">
                  <div *dxTemplate>
                    <dx-drop-down-box
                      class="reconciliation-dashboard__period-drop-down"
                      [label]="'Current year period'"
                      labelMode="floating"
                      [dataSource]="draftPeriodOptionsSig()"
                      [value]="draftSetup.currentYearPeriods"
                      valueExpr="id"
                      displayExpr="text"
                      fieldTemplate="currentYearPeriodField"
                      [deferRendering]="false"
                      [showClearButton]="false"
                      [dropDownOptions]="{
                        maxHeight: 200,
                        hideOnParentScroll: false,
                        container: '.reconciliation-dashboard__modal',
                        wrapperAttr: { class: 'reconciliation-dashboard__period-drop-down-popup' },
                      }"
                      (onOpened)="handlePeriodDropDownOpened()"
                      (onClosed)="handlePeriodDropDownClosed()"
                    >
                      <dx-validator [validationGroup]="setupValidationGroup">
                        <dxi-validation-rule type="required" [message]="Messages.REQUIRED_TEXT"></dxi-validation-rule>
                        <dxi-validation-rule
                          type="custom"
                          [validationCallback]="validateDraftPeriodsRequired"
                          message="Select at least one reporting period"
                        ></dxi-validation-rule>
                      </dx-validator>

                      <div *dxTemplate="let _ of 'currentYearPeriodField'">
                        <dx-text-box
                          [value]="getCurrentYearPeriodsDisplayText()"
                          [readOnly]="true"
                        ></dx-text-box>
                      </div>

                      <div *dxTemplate="let _ of 'content'" class="reconciliation-dashboard__period-drop-down-content">
                        <dx-list
                          [dataSource]="draftPeriodOptionsSig()"
                          keyExpr="id"
                          displayExpr="text"
                          [selectedItemKeys]="draftSetup.currentYearPeriods"
                          [selectionMode]="'all'"
                          [selectAllMode]="'allPages'"
                          [showSelectionControls]="true"
                          [selectByClick]="true"
                          [height]="200"
                          [scrollingEnabled]="true"
                          (onSelectionChanged)="onDraftCurrentYearPeriodListSelectionChanged($event)"
                        ></dx-list>
                      </div>
                    </dx-drop-down-box>
                  </div>
                </dxi-item>
              }
            }
          </dxi-item>
        </dx-form>

        <div class="reconciliation-dashboard__modal-preview">
          <div class="reconciliation-dashboard__modal-preview-title">Preview</div>
          <p class="reconciliation-dashboard__modal-preview-copy">{{ getDisplayedSetupSummary() }}</p>
        </div>

        <div class="reconciliation-dashboard__modal-actions">
          <div class="reconciliation-dashboard__modal-actions-left">
            <dx-button text="RESET DEFAULTS" type="normal" stylingMode="text" (onClick)="resetSetupDraft()"></dx-button>
          </div>
          <div class="reconciliation-dashboard__modal-actions-right">
            <dx-button text="CANCEL" type="normal" stylingMode="outlined" (onClick)="closeSetupModal()"></dx-button>
            <dx-button text="APPLY SETUP" type="default" stylingMode="contained" (onClick)="applySetup()"></dx-button>
          </div>
        </div>
      </div>
    </dx-popup>

    <div #contentContainer class="reconciliation-dashboard__content">
      <dx-scroll-view class="reconciliation-dashboard__scroll-view" [useNative]="false" [showScrollbar]="'always'">
        @if (loadErrorMessageSig()) {
          <div class="reconciliation-dashboard__scroll-content">
            <div class="reconciliation-dashboard__error-state">
              <div class="reconciliation-dashboard__error-eyebrow">Reconciliation report unavailable</div>
              <h3 class="reconciliation-dashboard__section-title">We couldn't load this dashboard</h3>
              <p class="reconciliation-dashboard__section-copy">{{ loadErrorMessageSig() }}</p>
              <dx-button
                text="TRY AGAIN"
                type="default"
                stylingMode="contained"
                [disabled]="isLoadingSig()"
                (onClick)="retryLoad()"
              ></dx-button>
            </div>
          </div>
        } @else {
          <div class="reconciliation-dashboard__scroll-content">
            <section class="reconciliation-dashboard__section">
              <div class="reconciliation-dashboard__section-header">
                <div>
                  <h3 class="reconciliation-dashboard__section-title">Carrier reconciliation totals</h3>
                  <p class="reconciliation-dashboard__section-copy">
                    Carriers are listed alphabetically. Each column compares the same reporting-week period across the
                    selected years using reconciliation totals.
                  </p>
                </div>
              </div>

              <div class="reconciliation-dashboard__grid-card">
                <div class="reconciliation-dashboard__grid-title">Weekly totals by carrier</div>
                <div class="reconciliation-dashboard__grid-shell">
                  <dx-data-grid
                    class="reconciliation-dashboard__grid"
                    [dataSource]="gridDataSourceSig()"
                    [columns]="gridColumnsSig()"
                    [showBorders]="true"
                    [columnAutoWidth]="false"
                    [allowColumnResizing]="true"
                    [wordWrapEnabled]="true"
                    [hoverStateEnabled]="true"
                    [noDataText]="'No reconciliation totals found for the selected setup.'"
                    height="100%"
                    (onCellPrepared)="onReconciliationGridCellPrepared($event)"
                  >
                    <dxo-load-panel [enabled]="false"></dxo-load-panel>
                    <dxo-paging [enabled]="false"></dxo-paging>
                    <dxo-sorting mode="single"></dxo-sorting>
                    <dxo-scrolling mode="standard" showScrollbar="always"></dxo-scrolling>
                    <dxo-filter-row [visible]="false"></dxo-filter-row>
                    <dxo-header-filter [visible]="false"></dxo-header-filter>
                    <dxo-search-panel
                      [visible]="false"
                      [width]="260"
                      placeholder="Search carrier..."
                    ></dxo-search-panel>
                    <dxo-state-storing
                      [enabled]="true"
                      type="localStorage"
                      storageKey="ag-crm.production-reconciliation-dashboard-grid.v1"
                      [savingTimeout]="500"
                    ></dxo-state-storing>
                    @if (gridSummaryTotalItemsSig().length) {
                      <dxo-summary [calculateCustomSummary]="calculateReconciliationGridCustomSummary">
                        @for (summaryItem of gridSummaryTotalItemsSig(); track summaryItem.dataField) {
                          <dxi-total-item
                            summaryType="custom"
                            [name]="summaryItem.dataField"
                            [column]="summaryItem.dataField"
                            [showInColumn]="summaryItem.dataField"
                            displayFormat="{0}"
                          ></dxi-total-item>
                        }
                      </dxo-summary>
                    }
                    <div *dxTemplate="let cell of 'reconciliationMetricCell'">
                      @if (buildMetricCellViewModel(cell.value, cell.column.metricFormat); as cellViewModel) {
                        <div class="reconciliation-dashboard__metric-cell">
                          <div class="reconciliation-dashboard__metric-values">{{ cellViewModel.primary }}</div>
                          @if (cellViewModel.change) {
                            <div class="reconciliation-dashboard__metric-change" title="Change">{{ cellViewModel.change }}</div>
                          }
                        </div>
                      }
                    </div>
                  </dx-data-grid>
                </div>
              </div>
            </section>
          </div>
        }
      </dx-scroll-view>

      <dx-load-panel
        [container]="contentContainer"
        [position]="{ my: 'center', at: 'center', of: contentContainer }"
        [visible]="isLoadingSig()"
        [showIndicator]="true"
        [showPane]="true"
        [shading]="true"
        shadingColor="rgba(255,255,255,0.7)"
      ></dx-load-panel>
    </div>
  </div>
</div>
